import Voiceover from './Voiceover'

export default Voiceover
